import { useTranslation } from 'react-i18next';

import useStyles from './styles';

function NoResults() {
  const { t } = useTranslation();
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <img
        src="https://cdn140.picsart.com/59889136492251304750.png"
        className={classes.image}
        alt="Copywriter"
      />
      <span className={classes.text}>{t('editor.results.sensitiveContent')}</span>
    </div>
  );
}
export default NoResults;
